import * as React from 'react';
import style from './CustomLabel.scss';
import { ReactMarkdownDisplay } from '../../../../PageElements/ReactMarkdownDisplay';
import { Popover } from 'wix-style-react';
import { Badge } from '../../../../PageElements/Badge';

export const CustomLabel = ({
  dataHook = 'custom-label',
  name,
  description,
  color,
  className,
}) => {
  const [shouldShowTooltip, setShoulShowTooltip] = React.useState(false);

  const open = () => description && setShoulShowTooltip(true);
  const close = () => description && setShoulShowTooltip(false);

  return (
    <Popover
      animate
      appendTo="window"
      dataHook="custom-label-tooltip"
      shown={shouldShowTooltip}
      placement="bottom"
      onMouseEnter={open}
      onMouseLeave={close}
      showArrow
      moveBy={{ x: 5 }}
    >
      <Popover.Element>
        <Badge color={color} dataHook={dataHook} className={className}>
          {name}
        </Badge>
      </Popover.Element>
      <Popover.Content>
        <div className={style.tooltipContent}>
          <ReactMarkdownDisplay markdown={description} />
        </div>
      </Popover.Content>
    </Popover>
  );
};
